import { render, staticRenderFns } from "./AppSideMenu.vue?vue&type=template&id=f724ef3a&scoped=true&"
import script from "./AppSideMenu.vue?vue&type=script&lang=js&"
export * from "./AppSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppSideMenu.vue?vue&type=style&index=0&id=f724ef3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f724ef3a",
  null
  
)

export default component.exports